// Límites del plan gratuito. Única fuente de verdad: el servidor los aplica
// y los clientes (web, mobile) los usan para mostrar avisos antes de llegar al límite.
// CommonJS y sin sintaxis moderna para que lo consuman Node, CRA y Metro sin transpilar.
const FREE_LIMITS = Object.freeze({
  workspaces: 1,
  habits: 5,
  notes: 15,
  activeTasks: 20,
  routines: 3
});

const PREMIUM_PLANS = Object.freeze(['premium']);

const hasUnlimitedPlan = (plan, role) => role === 'ADMIN' || PREMIUM_PLANS.includes(plan);

module.exports = { FREE_LIMITS, PREMIUM_PLANS, hasUnlimitedPlan };
